/**
 * Created by mestrad on 2018. 06. 28..
 */

export default SearchForm;
import Common from '../../Common';
import Summary from "./Summary";
import Geo from "./Geo";
import Person from "./Person";
import Corporate from "./Corporate";
import Memorial from "./Memorial";

const $ = jQuery;

function SearchForm(config) {
    var $wrapperObj = $(config.domElements.wrapperSelector);
    var $baseForm = config.$baseForm = $(config.domElements.searchForm);
    var $searchMap;
    var $searchTimeLine;
    var customSearch;
    var AvailableTypes = {
        Summary: Summary,
        Geo: Geo,
        Person: Person,
        Corporate: Corporate,
        Memorial: Memorial
    };
    init();
    function init() {
        if (config.domElements.searchMapSelector) {
            $searchMap = $(config.domElements.searchMapSelector);
        }
        if (config.domElements.searchTimeLineSelector) {
            $searchTimeLine = $(config.domElements.searchTimeLineSelector);
        }
        initEvents();
    }

    function initEvents() {
        $baseForm.on("getExtraFilters", function () {
            const searchParam = new URL( window.location.href ).searchParams.get( 'custom_filter' );
            const urlParams = Common.isJsonString( searchParam ) ? JSON.parse( searchParam ) : {};
            var custom_filter = {};

            if ( urlParams &&
                ( typeof $baseForm.data( 'custom_filter' ) === 'undefined' ||
                    +Common.getUrlParam( 'load', window.location ) === 1 ) ) {
                Object.entries( urlParams ).forEach(
                    ( [ filterType, filters ] ) => {
                        const mapFilter = {};
                        if ( filters.hasOwnProperty( 'coordinates' ) ) {
                            mapFilter.boundPolygon = filters.coordinates;
                            $baseForm.data( 'custom_filter', mapFilter );
                        }
                        if ( filters.hasOwnProperty( 'distance' ) ) {
                            mapFilter.radius = filters.distance;
                            $baseForm.data( 'custom_filter', mapFilter );
                        }
                        custom_filter[ filterType ] =
                            ! filters.hasOwnProperty( 'coordinates' ) ?
                            filters.map( filterValue => {
                                const items =
                                    Array.isArray( filterValue.items[ 0 ] ) ?
                                    filterValue.items.map( item => item[ 0 ] ) :
                                    filterValue.items;
                                return { ...filterValue, items };
                            } ) : filters;
                    } );
            }

            var boundPolygon = {};
            var customFilter = $baseForm.data( 'custom_filter' );

            if ( customFilter && customFilter.boundPolygon ) {
                boundPolygon = customFilter.boundPolygon.coordinates ||
                    customFilter.boundPolygon;
                if ( ! customFilter.radius ) {
                    customFilter.radius = null;
                }
            }

            var connectionTypes = [
                'birth_place',
                'death_place',
                'parent',
                'location_details',
                'related_person_profession',
                'related_person',
                'related_corporate'
            ];
            var searchTypes = [];
            var connections = [];
            var identifiers = [];
            $("#customSearchWrapper select").each(function () {
                var item = $("#" + this.id);
                if (item.hasClass(config.domElements.filterTypesClass)) {
                    var result;
                    var relation = 'and';
                    result = getInputValues(item);
                    if (item.val() !== 'timeline' && item.val() !== 'map' &&
                        typeof result !== 'undefined' &&
                        result.value.length === 0) {
                        return true;
                    }
                    if (item.val() === 'map' &&
                        typeof boundPolygon === 'undefined') {
                        return true;
                    }
                    if (item.val() === "map") {
                        if ( !! $baseForm.data( 'custom_filter' ).radius ) {
                            custom_filter[ 'geoDistance' ] = {
                                coordinates: boundPolygon,
                                distance: $baseForm.data('custom_filter').radius,
                                operator: relation
                            };
                        } else {
                            custom_filter[ 'boundPolygon' ] = {
                                coordinates: boundPolygon,
                                operator: relation
                            };
                        }
                    } else if (item.val() == "timeline") {
                        custom_filter[ 'nnp_search_date_from' ] = {
                            date: $baseForm.find(
                                config.domElements.searchDateFrom )
                                .val()
                                .replace( /\s/g, '' ),
                            operator: relation
                        };
                        custom_filter[ 'nnp_search_date_to' ] = {
                            date: $baseForm.find(
                                config.domElements.searchDateTo )
                                .val()
                                .replace( /\s/g, '' ),
                            operator: relation
                        };
                    } else if ($.inArray($(item).val(), connectionTypes) >= 0) {
                        result = getInputValues(item);
                        if (result != undefined) {
                            connections.push({
                                operator: result.relation,
                                type: item.val(),
                                items: result.value
                            });
                        }
                    } else if ($(item).val() == "identifier") {
                        result = getInputValues(item);
                        identifiers.push({
                            type: getSelectValue(item),
                            value: result.value,
                            operator: result.relation
                        });
                    } else {
                        result = getInputValues(item);
                        searchTypes.push({
                            type: result.type,
                            items: result.value,
                            operator: result.relation
                        });
                    }
                }
            });
            if (searchTypes.length > 0) custom_filter["nnp_search_types"] = formatValues(searchTypes);
            if (connections.length > 0) custom_filter["nnp_search_connections"] = formatValues(connections);
            if (identifiers.length > 0) custom_filter["nnp_search_identifiers"] = formatValues(identifiers);
            $baseForm.data("custom_filter", custom_filter);
        });

        $searchMap.on("change", function (event, feed) {
            var custom_filter = $baseForm.data("custom_filter") || {};
            custom_filter["boundPolygon"] = feed.bounds;
            custom_filter[ 'radius' ] = typeof feed.radius !== 'undefined'
                                        ? feed.radius + 'm'
                                        : null;
            $baseForm.data("custom_filter", custom_filter);
        });
    }

    function formatValues(oldArray) {
        var newArray = [];
        oldArray.forEach(function (item) {
            /*
            if (existsTypeInArray(newArray, item.type)) {
                newArray.forEach(function (element, index) {
                    if(element.type === item.type){
                        var items = element.items.concat(item.items);
                        newArray[index].items = items;
                    }
                });
            } else {
            */
                newArray.push({
                    type: item.type,
                    items: item.items,
                    operator: item.operator
                });
            /*
            }
            */
        });
        return newArray;
    }

    function existsTypeInArray(array, type) {
        let exists = false;
        array.forEach((item) => {
            if(item.type === type){
                exists = true;
            }
        });

        return exists;
    }

    function getInputValues(item) {
        var items = item.next().children();
        var type = item.val();
        var value;
        var relation;
        items.each(function (index, element) {
            if ($(element).hasClass("filter_input")) {
                var data = $(element).select2('data');
                value = data.map((item) => {
                    return item.id;
                });
            }
            if ($(element).hasClass("filter_relation")) {
                relation = $(element).val();
            }
        });
        return {
            type: type,
            value: value,
            relation: relation
        };
    }

    function getSelectValue(item) {
        var items = item.next().children();
        var value;
        items.each(function (index, element) {
            if ($(element).hasClass("filter_options")) {
                value = $(element).val();
            }
        });
        return value;
    }

    this.renderCustom = function () {
        if (AvailableTypes[config.objectType]) {
            customSearch = new AvailableTypes[config.objectType](config);
            customSearch.render({
                $wrapperObj: $wrapperObj,
                $searchMap: $searchMap,
                $searchTimeLine: $searchTimeLine,
            });

            $( document ).on(
                'change, click',
                '.menu-item, .filter_input, .removeFilterBtn',
                    e => {
                    const activeFilters = Array.from( document.querySelectorAll(
                        `.select2-selection__rendered .select2-selection__choice` ) )
                        .map( e => e.dataset.select2Id );
                    Array.from( document.querySelectorAll(
                        `#search_extra_info_filter button[data-filter-id]` ) )
                        .forEach( e => {
                            const { dataset: filterId } = e;
                            if ( !! activeFilters.includes( filterId ) ) {
                                return;
                            }
                            e.classList.remove( 'active' );
                        } );
                    }
                         )
                         .on( 'click', '#filter_box_container', e => {
                             e.target.closest( 'details' ).classList.remove( 'hover' );
                         } )
                         .on( 'mouseover', '#filter_box_container', e => {
                             const container = e.target.closest( 'details' );
                             if ( ! container.hasAttribute( 'open' ) ) {
                                 container.setAttribute( 'open', true );
                                 container.classList.add( 'hover' );
                             }
                         } )
                         .on( 'mouseout', '#filter_box_container', e => {
                             const container = e.target.closest( 'details' );
                             if ( [ ...container.classList ].includes( 'hover' ) ) {
                                 container.removeAttribute( 'open' );
                                 container.classList.remove( 'hover' );
                             }
                         } );

            $(".addFilterBtnFix").on("click", function () {
                customSearch.createFilter();
            });

            $( '#search_extra_info_filter' ).on( 'click', 'button', e => {
                e.preventDefault();
                const { target: btn } = e;
                const searchWrapper = btn.closest( '.nnpSearchWrapper' );

                if ( ! searchWrapper
                    || ! btn.dataset.hasOwnProperty( 'filterType' )
                    || ! btn.dataset.hasOwnProperty( 'filterId' )
                    || ! btn.dataset.hasOwnProperty( 'filterName' ) ) {
                    return;
                }

                const {
                    dataset: {
                        filterType: type,
                        filterId: id,
                        filterName: name
                    }
                } = btn;

                const activeFilters = Array.from(
                    searchWrapper.querySelectorAll(
                        `.select2-selection__rendered .select2-selection__choice` ) )
                    .map( e => e.title );

                if ( !! activeFilters.includes( name ) ) {
                    return;
                }

                customSearch.createFilter( type, [ {
                    id: id, text: name
                } ] );
                btn.classList.add( 'active' );
            } );
        }
    }

    $( document ).on( 'ready', async function () {
        const searchParam = new URL( window.location.href ).searchParams.get( 'custom_filter' );
        const customFilter = Common.isJsonString( searchParam ) ? JSON.parse( searchParam ) : {};

        if ( !customFilter || customFilter === {} ) {
            return;
        }

        const waitUntil = conditionFunction => {
            const poll = resolve => {
                if ( conditionFunction() ) {
                    resolve();
                } else {
                    setTimeout( _ => poll( resolve ), 400 );
                }
            };
            return new Promise( poll );
        };

        const searchTypes = customFilter.nnp_search_types || [];
        const searchConnections = customFilter.nnp_search_connections || [];
        const filterEntries = searchTypes.concat( searchConnections );
        let totalFilter = 0;

        for ( const filterData of filterEntries ) {
            const i = filterEntries.indexOf( filterData );
            if ( [ 'search', 'id', 'date' ].includes( filterData[ 0 ] ) ) {
                continue;
            }

            if ( i > 0 &&
                $( config.domElements.wrapperSelector ).find( '.addFilterBtn' ).length <= i - 1 ) {
                await waitUntil( () => $( config.domElements.wrapperSelector )
                    .find( '.addFilterBtn' ).length > i - 1 );
            }

            customSearch.createFilter( filterData.type,
                filterData.items.map( e => ( {
                    id: e[ 0 ], text: e[ 1 ]
                } ) ), filterData.operator );
            totalFilter++;
        }

        if ( customFilter.boundPolygon || customFilter.geoDistance ) {
            if ( $( config.domElements.wrapperSelector ).children().length !== totalFilter ) {
                await waitUntil( () => $( config.domElements.wrapperSelector ).children().length === totalFilter );
            }
            customSearch.createFilter( 'map' );
            totalFilter++;
        }
    } );
}
